import { CaseType } from '../../models';

export function useCaseType(): CaseType {
  const caseType = CaseType.Orthodontics;

  return caseType;
}
